import { withNamespaces } from "react-i18next";
import { Card, CardBody } from "reactstrap";

import { isDpo } from "src/modules/data-protection/constants/organizationFunctions";

import DpoAssignment from "./components/dpo-assignment";
import MembersAssignment from "./components/members-assignment";
import UsedFor from "./components/used-for";

const AssignedUsers = ({
    t,
    organizationFunction,
    pendingDpoUser,
    onPendingDpoUserChange,
}) => {
    const isDpoFunction = isDpo(organizationFunction?.key);
    const hasAssignedUser = Array.isArray(organizationFunction?.assigned_users)
        ? organizationFunction.assigned_users.length > 0
        : false;

    return (
        <>
            <Card>
                <CardBody>
                    <h4 className="card-title">
                        {t(isDpoFunction ? "Assigned User" : "Assigned User(s)")}
                    </h4>
                    {isDpoFunction ? (
                        <DpoAssignment
                            organizationFunction={organizationFunction}
                            pendingUser={pendingDpoUser}
                            onPendingUserChange={onPendingDpoUserChange}
                        />
                    ) : (
                        <MembersAssignment
                            organizationFunction={organizationFunction}
                        />
                    )}
                </CardBody>
            </Card>
            {isDpoFunction && hasAssignedUser ? <UsedFor /> : null}
        </>
    );
};

export default withNamespaces()(AssignedUsers);
